import { render, staticRenderFns } from "./SectionAgencyLegalInformationOgrn.vue?vue&type=template&id=168f11e3&"
import script from "./SectionAgencyLegalInformationOgrn.vue?vue&type=script&lang=js&"
export * from "./SectionAgencyLegalInformationOgrn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports